import { Component, OnInit, OnDestroy, ViewEncapsulation } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { URLSearchParams } from '@angular/http';
import { Subscription }   from 'rxjs/Subscription';

import { AuthService } from '../../../providers/auth.service';
import { SharedHackService } from '../shared/services/shared-hack.service';
import { ScreenTalentService } from './screen-talent.service';
import { SegmentioService } from '../../../providers/segmentio.service';

declare var $: any;


export class ScreenTalentComponent implements OnInit, OnDestroy {

	public state: any = {
		view: 'tests-list',
		activeTest: null,
		context: {}
	};

	public candidates: any = {
		pendingCount: null,
		completedCount: null
	};

	public eventsSubscription: Subscription;

	constructor(
		private authService: AuthService,
		private titleService: Title,
		private sharedHackService: SharedHackService,
		private screenTalentService: ScreenTalentService,
		private segmentioService: SegmentioService) {
		this.setAppTitle();
	}

	public setAppTitle(): void  {
		this.titleService.setTitle('hackajob.co - Screen Talent');
	}

	// Lifecycle Events
	public ngOnInit(): void {
		this.segmentioService.page();
		this.eventsSubscription = this.screenTalentService.emitEventAction$.subscribe(
			(data) => {
				this.fetchEvent(data);
			}
		);
	}

	public ngOnDestroy(): void {
		if (this.eventsSubscription) {
			this.eventsSubscription.unsubscribe();
		}
	}

	// Events
	public onMenuChange(view: string,  checkForPermission?: boolean): void {
		if (checkForPermission) {
			if (this.state.view === 'test-add' || (this.state.activeTest && this.state.activeTest.status === 'in_progress')) {
				return;
			}
		}
		this.state.view = view;
		this.screenTalentService.emitEventAction({ component: 'test', action: 'changeView', data: view });
	}

	public onInviteCandidateClick(): void {
		if (!this.state.activeTest || this.state.activeTest.status !== 'finished' || this.state.view === 'test-add') {
			return;
		}
		this.onMenuChange('invite-candidate');
	}

	public onViewTestClick(test: any): void {
		this.state.activeTest = test;
		this.state.context.isEdit = false;
		this.onMenuChange('summary');
		this.getAllCandidates();
	}

	public onEditTestClick(test: any): void {
		this.state.activeTest = test;
		this.state.context.isEdit = true;
		this.onMenuChange('summary');
		this.getAllCandidates();
	}

	// Service Call
	private getPendingCandidates(): void {
		if (this.state.activeTest) {
			this.candidates.pendingCount = null;
			let queryParams = new URLSearchParams();
			queryParams.append('statuses[]', 'pending');
			queryParams.append('statuses[]', 'started');
			this.sharedHackService.getExternalTestInvitationsCount(String(this.authService.userId), this.state.activeTest.id, queryParams).subscribe(
				(stats) => {
					this.candidates.pendingCount = stats.total;
				}
			);
		}
	}

	private getCompletedCandidates(): void {
		if (this.state.activeTest) {
			this.candidates.completedCount = null;
			let queryParams = new URLSearchParams();
			queryParams.set('status', 'completed');
			this.sharedHackService.getExternalTestInvitationsCount(String(this.authService.userId), this.state.activeTest.id, queryParams).subscribe(
				(stats) => {
					this.candidates.completedCount = stats.total;
				}
			);
		}
	}

	// Helpers
	private getAllCandidates(): void {
		this.getPendingCandidates();
		this.getCompletedCandidates();
	}

	private fetchEvent(event: any): void {
		if (event.component && event.component === 'screen-talent' && event.action) {
			switch (event.action) {
				case 'changeView':
					this.onMenuChange(event.data);
					break;
				case 'testCreated':
					if (!event.data) {
						this.onMenuChange('summary');
						return;
					}
					this.onViewTestClick(event.data);
					break;
				case 'viewTest':
					this.onViewTestClick(event.data);
					break;
				case 'editTest':
					this.onEditTestClick(event.data);
					break;
				case 'addTest':
					this.onViewTestClick(event.data);
					break;
				case 'getTest':
					this.state.activeTest = event.data;
					break;
				case 'updatePendingCandidatesCount':
					this.candidates.pendingCount = +event.data;
					break;
				case 'updateCompletedCandidatesCount':
					this.candidates.completedCount = +event.data;
					break;
				case 'candidateInvited':
					this.candidates.pendingCount += 1;
					break;
				default:
					break;
			}
		}
	}
static ctorParameters() { return [ { type: AuthService }, { type: Title }, { type: SharedHackService }, { type: ScreenTalentService }, { type: SegmentioService } ]; }}



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/components/client/screen-talent/screen-talent.component.ts